import { Inject, Injectable, InjectionToken } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import {
  type FindMethodTypeForSampleOutput,
  type IFindMethodTypeForSampleQuery,
} from '@protocols/use-cases';

import { MethodTypeState } from '../state/method-type.state';
import { tapResponse } from '@ngrx/operators';

export const FIND_METHOD_TYPE_FOR_SAMPLE_QUERY = new InjectionToken<IFindMethodTypeForSampleQuery>(
  'FIND_METHOD_TYPE_FOR_SAMPLE_QUERY'
);

@Injectable()
export class MethodTypeEffects {
  constructor(
    private readonly state: MethodTypeState,
    @Inject(FIND_METHOD_TYPE_FOR_SAMPLE_QUERY)
    private readonly findMethodTypeForSampleQuery: IFindMethodTypeForSampleQuery
  ) {}

  // ============================================================================
  // Re-exposed selectors
  // ============================================================================

  public readonly methodType$ = this.state.methodType$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  // ============================================================================
  // Re-exposed updaters
  // ============================================================================

  public readonly setMethodType = this.state.setMethodType;

  // ============================================================================
  // Effects
  // ============================================================================

  public readonly findForSample = this.state.effect((sampleId$: Observable<string>) =>
    sampleId$.pipe(
      tap(() => {
        this.state.setLoading(true);
        this.state.setError(null);
      }),
      switchMap((sampleId) =>
        from(this.findMethodTypeForSampleQuery.execute(sampleId)).pipe(
          tapResponse(
            (output: FindMethodTypeForSampleOutput | undefined) => {
              this.state.setMethodType(output ?? null);
              this.state.setLoading(false);
            },
            (error: Error) => {
              this.state.setError(error.message);
              this.state.setLoading(false);
            }
          )
        )
      )
    )
  );
}
